import { isDockTopRatio } from '@/helpers/botFabPosition'

const keyFor = (namespace = 'bottleBot') =>
  namespace === 'bottleBot' ? 'bottleBotWidget' : `bottleBotWidget:${namespace}`

// Every writer merges onto the stored blob: mode and the UI preferences share one
// key so logout wipes both, and neither may erase the other on the way past.
function mergeWidgetState(patch, namespace) {
  try {
    localStorage.setItem(keyFor(namespace), JSON.stringify({ ...loadWidgetState(namespace), ...patch }))
  } catch {
    // storage unavailable; continuity is best-effort
  }
}

export function saveWidgetState({ mode, conversationId }, namespace = 'bottleBot') {
  mergeWidgetState({ mode, conversationId: conversationId ?? null }, namespace)
}

// dockTopRatio is a fraction of the viewport height, never a pixel offset: the
// launcher is placed on one screen and read back on another. A pixel value left by
// an older build lands under no key we read, so it is ignored rather than trusted.
export function saveWidgetPrefs(prefs = {}, namespace = 'bottleBot') {
  const patch = {}
  if ('stowed' in prefs) patch.stowed = prefs.stowed === true
  if ('tipSeen' in prefs) patch.tipSeen = prefs.tipSeen === true
  if ('dockTopRatio' in prefs) patch.dockTopRatio = isDockTopRatio(prefs.dockTopRatio) ? prefs.dockTopRatio : null
  mergeWidgetState(patch, namespace)
}

export function loadWidgetPrefs(namespace = 'bottleBot') {
  const { stowed, tipSeen, dockTopRatio } = loadWidgetState(namespace)
  return {
    stowed: stowed === true,
    tipSeen: tipSeen === true,
    dockTopRatio: isDockTopRatio(dockTopRatio) ? dockTopRatio : null
  }
}

export function loadWidgetState(namespace = 'bottleBot') {
  try {
    return JSON.parse(localStorage.getItem(keyFor(namespace))) || {}
  } catch {
    return {}
  }
}

export function clearWidgetState(namespace = 'bottleBot') {
  try {
    localStorage.removeItem(keyFor(namespace))
  } catch {
    // storage unavailable; continuity is best-effort
  }
}

export async function restoreWidgetState({ openConversation, setMode }, saved = {}, namespace = 'bottleBot') {
  try {
    if (saved.conversationId) await openConversation(saved.conversationId)
  } catch {
    clearWidgetState(namespace) // stale or foreign conversation; start with a clean slate
    return
  }
  if (saved.mode && saved.mode !== 'hidden') setMode(saved.mode)
}
